import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

/** Shared horizontal gutter for interests onboarding header and body content. */
export const INTERESTS_HORIZONTAL_GUTTER = theme.spacing['spacing.general.x4'];
